<template>
    <el-table
        :data="tableData"
        style="width: 100%"
        :cell-style="{
            'font-size': '16px',
            color: '#333',
        }"
        :header-cell-style="{
            'background-color': '#d7d7d7',
            'font-weight': '700',
            color: '#333',
            'font-size': '16px',
        }"
    >
        <el-table-column
            label="课程名称"
            prop="type"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div
                    style="color: #409eff; cursor: pointer"
                    @click="linkTo(scope.$index, scope.row)"
                >
                    {{ scope.row.type }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="建课老师"
            prop="total"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="建课学校"
            prop="signingUp"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="开课课时"
            prop="learning"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            prop="notLearn"
            label="报名中"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            prop="studyOver"
            label="开课中"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            prop="learnNum"
            label="未开课"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            prop="studyNum"
            label="已结课"
            align="center"
            header-align="center"
        ></el-table-column>
    </el-table>
</template>

<script>
export default {
    data() {
        return {
            tableData: [
                {
                    type: "班级课程",
                    total: "1",
                    signingUp: "2",
                    learning: "3",
                    notLearn: "4",
                    studyOver: "5",
                    learnNum: "6",
                    studyNum: "7",
                },
                {
                    type: "点播课程",
                    total: "1",
                    signingUp: "2",
                    learning: "3",
                    notLearn: "4",
                    studyOver: "5",
                    learnNum: "6",
                    studyNum: "7",
                },
                {
                    type: "直播课程",
                    total: "1",
                    signingUp: "2",
                    learning: "3",
                    notLearn: "4",
                    studyOver: "5",
                    learnNum: "6",
                    studyNum: "7",
                },
                {
                    type: "面授课程",
                    total: "1",
                    signingUp: "2",
                    learning: "3",
                    notLearn: "4",
                    studyOver: "5",
                    learnNum: "6",
                    studyNum: "7",
                },
            ],
        };
    },
    methods: {
        linkTo(i, item) {
            console.log(item);
        },
    },
};
</script>

